const LETTER_YEAR = '年度'

const KEY_LOCALSTORAGE = {
    anti_warming: 'anti-warming-filter',
    energy_saving: 'energy-saving-filter',
}

export { LETTER_YEAR, KEY_LOCALSTORAGE }
